export default {
  'DATA_RESUME': (state, data) => state.dataResume = data,
  'AUTH': (state, auth) => state.auth = auth
};
